import { i18n } from '../utils.js';

;(function( $, window, undefined ){

  'use strict';

  // global
  var Modernizr = window.Modernizr, $body = $('body');

  // taken from https://github.com/inuyaksa/jquery.nicescroll/blob/master/jquery.nicescroll.js
  function hasParent( e, id ) {
    if (!e) return false;
    var el = e.target||e.srcElement||e||false;
    while (el && el.id != id) {
      el = el.parentNode||false;
    }
    return (el!==false);
  }

  // returns the depth of the element "e" relative to element with id=id
  // for this calculation only parents with classname = waypoint are considered
  function getLevelDepth( e, id, waypoint, cnt ) {
    cnt = cnt || 0;
    if ( e.id.indexOf( id ) >= 0 ) return cnt;
    if( $(e).hasClass( waypoint ) ) {
      ++cnt;
    }
    return e.parentNode && getLevelDepth( e.parentNode, id, waypoint, cnt );
  }

  $.MenuPush = function( options, element ) {
    this.$el = $( element );
    this._init( options );
  };

  // options
  $.MenuPush.defaults = {
    // overlap: there will be a gap between open levels
    // cover: the open levels will be on top of any previous open level
    type : 'overlap', // overlap || cover
    // space between each overlaped level
    levelSpacing : 40,
    // classname for the element (if any) that when clicked closes the current level
    backClass : 'mp-back',
    wrapperSelector : '.mp-pusher',
    levelClass : 'mp-level',
    triggerClass : 'mp-trigger'
  };

  $.MenuPush.prototype = {
    _init : function( options ) {
      // options
      this.options = $.extend( true, {}, $.MenuPush.defaults, options );

      // cache some elements and initialize some variables
      this._config();

      // initialize / bind the necessary events
      this._initEvents();
    },
    _config : function() {
      // if menu is open or not
      this.open = false;
      // level depth
      this.level = 0;
      // the menu trigger
      this.$trigger = $( '.' + this.options.triggerClass );
      // the moving wrapper
      this.$wrapper = $( this.options.wrapperSelector );
      // the mp-level elements
      this.$levels = this.$el.find( '.' + this.options.levelClass );
      // save the depth of each of these mp-level elements
      var self = this;
      this.$levels.each( function( i ) {
        var el = this;
        el.setAttribute( 'data-level', getLevelDepth( el, self.$el[0].id, self.options.levelClass ) );

        // add back button to level panes if necessary
        if ( i > 0 && self.options.type === 'cover' ) {
          $(el).prepend(`<a class="mp-back" href="#">${i18n('form.back')}</a>`);
        }
      } );
      // the menu items
      this.$menuItems = this.$el.find('li');
      // if type == "cover" these will serve as hooks to move back to the previous level
      this.$levelBack = this.$el.find( '.' + this.options.backClass );
      // event type (if mobile use touch events)
      // this.eventtype = mobileCheck() ? 'touchstart' : 'click';
      this.eventtype = 'click';
      // add the class mp-overlap or mp-cover to the main element depending on options.type
      this.$el.addClass('mp-' + this.options.type);
    },
    _initEvents : function() {
      var self = this;

      // the menu should close if clicking somewhere on the body
      var bodyClickFn = function( el ) {
        self._resetMenu();
        el.removeEventListener( self.eventtype, bodyClickFn );
      };

      // open (or close) the menu
      this.$trigger.on( this.eventtype, function( ev ) {

        ev.stopPropagation();
        ev.preventDefault();

        if( self.open ) {
          self._resetMenu();
        } else {
          self._openMenu();
          // the menu should close if clicking somewhere on the body (excluding clicks on the menu)
          $(document).on( self.eventtype, function( ev ) {
            if( self.open && !hasParent( ev.target, self.$el[0].id ) ) {
              bodyClickFn( this );
            }
          } );
        }
      } );

      // opening a sub level menu
      this.$menuItems.each( function( i ) {
        var $el = $(this);
        // check if it has a sub level
        var $subLevel = $el.children( '.' + self.options.levelClass );
        if( $subLevel.length > 0 ) {
          $el.children( 'a' ).on( self.eventtype, function( ev ) {
            ev.preventDefault();

            var $closestLevel = $el.closest( '.' + self.options.levelClass );
            var level = $closestLevel.attr( 'data-level' );
            if( self.level <= level ) {
              ev.stopPropagation();

              $closestLevel.addClass('mp-level-overlay');
              self._openMenu( $subLevel[0] );
            }
          } );
        }
      } );

      // closing the sub levels :
      // by clicking on the visible part of the level element
      this.$levels.each( function( i ) {
        var $el = $(this);

        $el.on( self.eventtype, function( ev ) {
          ev.stopPropagation();

          var level = $el.attr( 'data-level' );
          if( self.level > level ) {
            self.level = level;
            self._closeMenu();
          }
        } );
      } );

      // by clicking on a specific element
      this.$levelBack.each( function( i ) {
        var $el = $(this);

        $el.on( self.eventtype, function( ev ) {
          ev.preventDefault();

          var $closestLevel = $el.closest( '.' + self.options.levelClass );
          var level = $closestLevel.attr( 'data-level' );
          if( self.level <= level ) {
            ev.stopPropagation();

            self.level = $closestLevel.attr( 'data-level' ) - 1;
            self.level === 0 ? self._resetMenu() : self._closeMenu();
          }
        } );
      } );
    },
    _openMenu : function( subLevel ) {
      // increment level depth
      ++this.level;

      // move the main wrapper
      var levelFactor = ( this.level - 1 ) * this.options.levelSpacing,
        translateVal = this.options.type === 'overlap' ? this.$el[0].offsetWidth + levelFactor : this.$el[0].offsetWidth;

      this._setTransform( 'translate3d(' + translateVal + 'px,0,0)' );

      if( subLevel ) {
        // reset transform for sublevel
        this._setTransform( '', subLevel );
        // need to reset the translate value for the level menus that have the same level depth and are not open
        for( var i = 0, len = this.$levels.length; i < len; ++i ) {
          var levelEl = this.$levels[i];
          if( levelEl != subLevel && !$(levelEl).hasClass( 'mp-level-open' ) ) {
            this._setTransform( 'translate3d(-100%,0,0) translate3d(' + -1*levelFactor + 'px,0,0)', levelEl );
          }
        }
      }
      // add class mp-pushed to main wrapper if opening the first time
      if( this.level === 1 ) {
        this.$wrapper.addClass('mp-pushed');
        this.open = true;
      }
      // add class mp-level-open to the opening level element
      var openingLevelEL = subLevel || this.$levels[0];
      $(openingLevelEL).addClass('mp-level-open');
    },
    // close the menu
    _resetMenu : function() {
      this._setTransform('translate3d(0,0,0)');
      this.level = 0;
      // remove class mp-pushed from main wrapper
      this.$wrapper.removeClass('mp-pushed');
      this._toggleLevels();
      this.open = false;
    },
    // close sub menus
    _closeMenu : function() {
      var translateVal = this.options.type === 'overlap' ? this.$el[0].offsetWidth + ( this.level - 1 ) * this.options.levelSpacing : this.$el[0].offsetWidth;
      this._setTransform( 'translate3d(' + translateVal + 'px,0,0)' );
      this._toggleLevels();
    },
    // translate the el
    _setTransform : function( val, el ) {
      el = el || this.$wrapper[0];
      el.style.WebkitTransform = val;
      el.style.MozTransform = val;
      el.style.transform = val;
    },
    // removes classes mp-level-open from closing levels
    _toggleLevels : function() {
      for( var i = 0, len = this.$levels.length; i < len; ++i ) {
        var $levelEl = $(this.$levels[i]);
        if( $levelEl.attr( 'data-level' ) >= this.level + 1 ) {
          $levelEl.removeClass('mp-level-open');
          $levelEl.removeClass('mp-level-overlay');
        }
        else if( Number( $levelEl.attr( 'data-level' ) ) == this.level ) {
          $levelEl.removeClass('mp-level-overlay');
        }
      }
    }
  }

  var logError = function( message ) {
    if ( window.console ) {
      window.console.error( message );
    }
  };

  $.fn.menuPush = function( options ) {
    if ( typeof options === 'string' ) {
      var args = Array.prototype.slice.call( arguments, 1 );
      this.each(function() {
        var instance = $.data( this, 'menupush' );
        if ( !instance ) {
          logError( "cannot call methods on menupush prior to initialization; " +
          "attempted to call method '" + options + "'" );
          return;
        }
        if ( !$.isFunction( instance[options] ) || options.charAt(0) === "_" ) {
          logError( "no such method '" + options + "' for menupush instance" );
          return;
        }
        instance[ options ].apply( instance, args );
      });
    }
    else {
      this.each(function() {
        var instance = $.data( this, 'menupush' );
        var support = Modernizr.csstransforms3d;

        if ( instance ) {
          if ( support ) {
            instance._init();
          }
        }
        else {
          if ( support ) {
            instance = $.data( this, 'menupush', new $.MenuPush( options, this ) );
          }
        }
      });
    }
    return this;
  };

})( jQuery, window );



// WEBPACK FOOTER //
// ./grails-app/assetsSrc/scripts/modules/menu-push.js